import { ITeam } from "../../../team-details/redux";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { GetStartedPageActions } from "../../redux";
import { TeamCreationPageActions } from "../../../create-team/redux";
import { dispatchFetchAllPotentialMembersIfEmpty } from "../../../teams/redux";
import { GITSCategoryActions } from "../redux";
import { useSelectorTyped } from "../../../../common/redux/store";

export default function useTeamInformationController() {
  const dispatch = useDispatch();
  const teamListPEV = useSelectorTyped((state) => state.getStartedPage.teamListForGITSPEV);
  const potentialMembersPEV = useSelectorTyped((state) => state.teamsPage.potentialMembersPEV);
  const { value: teamList, error: teamListError, progress: teamListProgress } = teamListPEV;

  useEffect(() => {
    dispatch(GetStartedPageActions.fetchMyActiveTeamsForGITS());
    dispatchFetchAllPotentialMembersIfEmpty(dispatch, potentialMembersPEV);
  }, []);

  const rowClickHandler = (row: ITeam) => {
    dispatch(GetStartedPageActions.updateCurrentStep("BASIC_INFO"));
    dispatch(GITSCategoryActions.updateBasicInfo({
      teamId: row.id,
      teamName: row.name,
    }));
  };

  const shouldRenderUserNotAssociatedToTeamMessage = () => teamList.length === 0;

  const shouldRenderProgressMessage = () => teamListProgress !== null && teamList.length === 0;

  const shouldRenderErrorMessage = () => !!teamListError;

  const onPrevious = () => {
    dispatch(GetStartedPageActions.updateCurrentStep("PROJECT_CLASSIFICATION"));
    dispatch(TeamCreationPageActions.resetState());
  };

  const getTeamList = () => teamList ?? [];

  return {
    getTeamList,
    rowClickHandler,
    shouldRenderUserNotAssociatedToTeamMessage,
    teamListError,
    teamListProgress,
    shouldRenderProgressMessage,
    shouldRenderErrorMessage,
    onPrevious,
  };
}
